import { ComponentKey } from 'enums/componentKey';
import { legalEntityFinancialsInputsConfig } from 'features/new-actor/form/inputs-config/optim/legalEntityFinancialsInputsConfig';
import { SubsidiaryFormField } from 'features/new-actor/types/optim/subsidiaryFormValues';
import { InputsConfig } from 'types/form/inputsConfig';

// Fields of the subsidiary dialog, bound to the dialog's own Formik (top-level names).
export const subsidiaryInputsConfig: InputsConfig<SubsidiaryFormField> = {
  companyName: {
    componentKey: ComponentKey.InputText,
    name: 'companyName',
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.SUBSIDIARIES.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.SUBSIDIARIES.PLACEHOLDERS.COMPANY_NAME'
  },
  registrationNumber: {
    componentKey: ComponentKey.InputText,
    name: 'registrationNumber',
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.REGISTRATION_NUMBER'
  },
  // Same figures as the parent company's accounting data, without the `financials.` prefix.
  revenue: { ...legalEntityFinancialsInputsConfig.revenue, name: 'revenue' },
  fiscalYearEnd: { ...legalEntityFinancialsInputsConfig.fiscalYearEnd, name: 'fiscalYearEnd' },
  employeesCount: { ...legalEntityFinancialsInputsConfig.employeesCount, name: 'employeesCount' }
};
